var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex",style:({
        'margin': _vm.hideRightMargin ? '10px 0 0 20px' : '10px 20px 0 20px',
        'justify-content': _vm.justify.length > 0 ? _vm.justify : '',
}),attrs:{"data-testid":"HorizontalAxis"}},_vm._l((_vm.formattedTimeTicks),function(timeTick){return _c('div',{key:timeTick.timestamp,staticClass:"tick"},[_vm._v(" "+_vm._s(timeTick.label)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }